import React, { memo } from "react";
import ModuleTabContent from "components/layout-components/ModuleTabContent";

import FacilityContact from "./FacilityContact";
import GroupContact from "./groupContact";
import ContractedHours from "./contractedHours"

// Tabs (titles/order) are in NavigationConfig's "facility" entry. Adhoc
// Facility, Adhoc Location and Outstanding Audit stay switched off, as before.
const screens = {
  group: <GroupContact />,
  facility: <FacilityContact />,
  "contracted-hours": <ContractedHours />,
};

const ContactDetail = () => <ModuleTabContent navKey="facility" screens={screens} framed />;

export default memo(ContactDetail);
